var _BaseServiceV2 = require('./core/_BaseServiceV2');

module.exports = _BaseServiceV2.create('assignment', {
	teacherGetAnnotations: {
		cache: 'teacherAnnotations',
		keyProperties: ['assignmentId', 'student']
	},
	studentGetAnnotations: {
		cache: 'studentAnnotations',
		keyProperties: ['assignmentId', 'productId']
	},
	createAnnotation: {
		cache: 'studentAnnotations',
		keyProperties: ['assignmentId', 'productId']
	},
	updateAnnotation: {
		cache: 'studentAnnotations',
		keyProperties: ['assignmentId', 'productId']
	},
	deleteAnnotation: {
		cache: 'studentAnnotations',
		keyProperties: ['assignmentId', 'productId']
	}
});
